import {
  CreditsConsumer,
  AuthorisationConsumer,
  RequestProvider
} from '@shootsta/common-react';
import FlexPurchasePaymentSuccessModalComponent from '../components/FlexPurchasePaymentSuccessModal';
import InvoicesContext, {
  InvoicesContextProvider
} from '../../../context/InvoicesContext';
import { getPaymentInvoice } from '../../../api';
import { getFinanceBalance as getFinanceBalanceRequest } from '../../../api/financeApi';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface FlexPurchasePaymentSuccessModalProps {
  visible: boolean;
  orderId: string;
  purchasedCredit: number;
  promoBonusCredits?: number;
  onClose: (args: boolean) => void;
}

function FlexPurchasePaymentSuccessModal(
  props: FlexPurchasePaymentSuccessModalProps
) {
  const flags = useFlags() || {};
  const financeLedgerEnabled = !!flags.financeLedgerEnabled;
  return (
    <AuthorisationConsumer>
      {({ selectedOrganisation: { organisationId } }) => (
        <CreditsConsumer>
          {({ state: { contractItemBalance } }) => (
            <RequestProvider
              requests={{
                getPaymentInvoice: getPaymentInvoice(),
                ...(financeLedgerEnabled && {
                  getFinanceBalance: getFinanceBalanceRequest(organisationId, {
                    silent: true
                  })
                })
              }}
            >
              {({ getPaymentInvoice, getFinanceBalance }) => (
                <InvoicesContextProvider getPaymentInvoice={getPaymentInvoice}>
                  <InvoicesContext.Consumer>
                    {({ actions: { openInvoices } }) => (
                      <FlexPurchasePaymentSuccessModalComponent
                        contractItemBalance={contractItemBalance}
                        organisationId={organisationId}
                        onViewInvoice={openInvoices}
                        financeLedgerEnabled={financeLedgerEnabled}
                        getFinanceBalance={getFinanceBalance}
                        {...props}
                      />
                    )}
                  </InvoicesContext.Consumer>
                </InvoicesContextProvider>
              )}
            </RequestProvider>
          )}
        </CreditsConsumer>
      )}
    </AuthorisationConsumer>
  );
}

export default FlexPurchasePaymentSuccessModal;
